// NPM Imports
import React, { useContext } from 'react'
// Quote Context
import { useQuoteContext } from '../../../hooks/useQuoteContext'
// Component Imports
import Description from '../../ui-helper-elements/Description'
import DiscountList from '../../ui-helper-elements/DiscountList'
// JS Imports
import {
   //@ts-ignore
   formatFloatAsCurrencySymbol,
   //@ts-ignore
   formatFloatAsPercent,
} from '../../../common/helpers.mjs'
// Asset Imports

export default function TotalMonthlyEffectiveDiscountRow() {
   const state = useQuoteContext()
   const { getString } = state

   if (state.monthlyTotal.totalDiscount > 0) {
      return (
         <div className='row'>
            <div className='col-bhr1 col-bhr5'>
               {getString('global.EffectiveTotalDiscount')}
            </div>
            <div className='col col-bhr-red'>
               {((state.product_list[state?.coreProductSelected]
                  ?.MinimumEmployees ?? 0) > (state.productCoreEECount ?? 0) &&
                  (state.productCoreEECount ?? 0) > 0) ||
               ((state.product_list['payroll']?.MinimumEmployees ?? 0) >
                  (state.productPayrollTotalEECount ?? 0) &&
                  (state.productPayrollTotalEECount ?? 0) > 0)
                  ? ''
                  : formatFloatAsCurrencySymbol(
                       state.monthlyTotal.totalPEPMDiscount,
                       state.currencyObject,
                    )}
            </div>
            <Description
               className='col col-bhr-red'
               title='Monthly Discounts'
               content={
                  <>
                     <DiscountList
                        discounts={state.monthlyTotal.appliedDiscounts}
                     ></DiscountList>
                     <div className='row'>
                        <div className='col text-nowrap'>
                           <b>{getString('global.TotalDiscount')}</b>
                        </div>
                        <div className='col col-bhr-red text-end'>
                           <b>
                              {formatFloatAsCurrencySymbol(
                                 state.monthlyTotal.totalDiscount,
                                 state.currencyObject,
                              )}
                           </b>
                        </div>
                     </div>
                     <br></br>
                     <div className='row'>
                        <div className='col text-nowrap'>
                           {getString('global.MonthlyListPrice')}
                        </div>
                        <div className='col text-end'>
                           {formatFloatAsCurrencySymbol(
                              state.monthlyTotal.listPrice,
                              state.currencyObject,
                           )}
                        </div>
                     </div>
                     <div className='row'>
                        <div className='col text-nowrap'>
                           {getString('global.TotalDiscount')}
                        </div>
                        <div className='col col-bhr-red text-end'>
                           {formatFloatAsCurrencySymbol(
                              state.monthlyTotal.totalDiscount,
                              state.currencyObject,
                           )}
                        </div>
                     </div>
                     <div className='row'>
                        <div className='col text-nowrap'>
                           <b>{getString('global.MonthlyTotal')}</b>
                        </div>
                        <div className='col text-end'>
                           <b>
                              {formatFloatAsCurrencySymbol(
                                 state.monthlyTotal.totalPrice,
                                 state.currencyObject,
                              )}
                           </b>
                        </div>
                     </div>
                     <br></br>
                     <div className='row'>
                        <div className='col text-nowrap'>
                           <b>{getString('global.EffectiveTotalDiscount')}</b>
                        </div>
                        <div className='col col-bhr-red text-end'>
                           <b>
                              {formatFloatAsPercent(
                                 state.monthlyTotal.totalDiscountPercent,
                              )}
                           </b>
                        </div>
                     </div>
                  </>
               }
            >
               <span className='hoverable'>
                  {formatFloatAsPercent(
                     state.monthlyTotal.totalDiscountPercent,
                  )}
               </span>
            </Description>
            <div className='col col-bhr-red'>
               {formatFloatAsCurrencySymbol(
                  state.monthlyTotal.totalDiscount,
                  state.currencyObject,
               )}
            </div>
         </div>
      )
   } else {
      return null
   }
}
